import { Input } from "@/components/ui/input";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";
import { useDebouncedSyncedString } from "../useDebouncedSyncedString";

export function InstagramButtonTextInput({
  step,
  buttonIndex,
  text,
  onStepButtonsChange,
}: {
  step: AutomationStep;
  buttonIndex: number;
  text: string;
  onStepButtonsChange: StepNodeData["onStepButtonsChange"];
}) {
  const { draft, onChange, onBlur, onFocus } = useDebouncedSyncedString({
    syncKey: `${step.id}-btn-${buttonIndex}`,
    externalValue: text,
    onCommit: ({ value }) => {
      const next = [...(step.data?.buttons ?? [])];
      const prevBtn = next[buttonIndex];
      next[buttonIndex] = { text: value, targetStepId: prevBtn?.targetStepId };
      onStepButtonsChange({ stepId: step.id, buttons: next });
    },
  });

  return (
    <Input
      value={draft}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder="Button text"
      className="flex-1 text-sm"
    />
  );
}
